import { ControlledCheckbox, ControlledInputField } from '../form-fields';
import { useFormContext, type DeepMap, type FieldError } from 'react-hook-form';
import SCVerificationCode from './css';
import SummaryPageTextBlock from './summary-page-text-block';
import MarketingConsent from '../marketing-consent';
import { RootState } from '../../reducers';
import { useSelector } from 'react-redux';
import { useIsNz } from '../../util/hooks';
import { useState } from 'react';
import { SCBlueCheckbox } from '../checkbox-sc-blue';

const VerificationCode = ({
  isEcommerce,
  customerId,
  errors,
}: {
  isEcommerce: boolean;
  customerId: string | null;
  errors: DeepMap<Record<string, any>, FieldError>;
}) => {
  const [yourPurchase, setYourPurchase] = useState<boolean>(false);
  const [notUnderHardship, setNotUnderHardship] = useState<boolean>(false);

  const globalFormState = useSelector((state: RootState) => state.customer);
  const idVerified = useSelector((state: RootState) => state.customer.customerDetails.isIdVerified);
  const isNz = useIsNz();

  const handleYourPurchaseClick = () => {
    setYourPurchase(!yourPurchase);
  };
  const handleNotUnderHardshipClick = () => {
    setNotUnderHardship(!notUnderHardship);
  };
  return (
    <SCVerificationCode>
      <SummaryPageTextBlock />
      <SCBlueCheckbox>
        <ControlledCheckbox
          handleClick={handleYourPurchaseClick}
          defaultValue={'false'}
          name={'yourPurchase'}
          checked={yourPurchase}
          multiline={true}
          rules={{
            validate: {
              test: () => {
                return !yourPurchase ? 'Required' : undefined;
              },
            },
          }}
          error={errors.yourPurchase?.message}
        >
          <div className="blue-text">
            Tick this box to confirm that you arranged or invited the sale of goods or services from
            the merchant or that you made your purchase from the merchant's business premises.
          </div>
        </ControlledCheckbox>
      </SCBlueCheckbox>
      <SCBlueCheckbox>
        <ControlledCheckbox
          handleClick={handleNotUnderHardshipClick}
          name={'notUnderHardship'}
          defaultValue={'false'}
          checked={notUnderHardship}
          error={errors.notUnderHardship?.message}
          multiline={true}
          rules={{
            validate: {
              test: () => {
                return !notUnderHardship ? 'Required' : undefined;
              },
            },
          }}
        >
          <div className="blue-text">
            Tick this box to confirm you are not experiencing circumstances of personal, lifestyle
            or financial vulnerability that would make it difficult for you to meet your obligations
            under your BNPL Contract. If you are experiencing any vulnerability we encourage you to
            contact a financial counsellor or other advisor before continuing with this application.
          </div>
        </ControlledCheckbox>
      </SCBlueCheckbox>
      {isNz ? (
        <MarketingConsent
          customerId={customerId}
          checkPromoConsent={globalFormState.customerDetails.consentPromoMaterial}
        />
      ) : !idVerified ? (
        <MarketingConsent
          customerId={customerId}
          checkPromoConsent={false}
          isEcommerce={isEcommerce}
        />
      ) : (
        <MarketingConsent
          customerId={customerId}
          checkPromoConsent={globalFormState.customerDetails.consentPromoMaterial}
          isEcommerce={isEcommerce}
        />
      )}
      {isEcommerce ? (
        <>
          <p>
            You're seconds away from an instant decision – just enter your{' '}
            <span className="bold">Verification Code</span> below and hit Submit.
          </p>
        </>
      ) : (
        <p>You're seconds away from an instant decision – just hit Submit.</p>
      )}
      {isEcommerce && (
        <div className="section-action-loansubmit">
          <ControlledInputField
            id="verificationcode"
            name="verificationcode"
            rules={{ required: 'Required' }}
            error={errors.verificationcode && 'Verification Code is required'}
          >
            Verification Code
          </ControlledInputField>
        </div>
      )}
    </SCVerificationCode>
  );
};

export default VerificationCode;
